import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

export let startChatbotServices = coursenum => {
  ReactDOM.render(
    <App coursenum={coursenum} />,
    document.getElementById('chatbot_services')
  )
}
